export default "__VITE_ASSET__BvAyIB2o__"